<div
    class="st-story-basic-text-editor__editor"
    [froalaEditor]="froalaOptions()"
    [froalaModel]="content()"></div>
